import { PROMO_RECOMMENDATION_TYPE } from 'app/constants/AnalyticsGa4Constants';

export default promoRecommendationType => {
  switch (promoRecommendationType) {
    case 'contextual':
      return PROMO_RECOMMENDATION_TYPE.CONTEXTUAL;
    case 'spotlight':
      return PROMO_RECOMMENDATION_TYPE.LIBRARY_RECOMMENDED;
    case 'timely':
      return PROMO_RECOMMENDATION_TYPE.TIMELY;
    default:
      return undefined;
  }
};
